import { makeAutoObservable } from "mobx";
import ApiStore from "./ApiStore";
import { Task } from "../api/TasksApiClient";

class TaskStore {
  isLoading: boolean = false;
  tasks: Task[] = [];
  ApiStore!: ApiStore;

  constructor(apiStore: ApiStore) {
    makeAutoObservable(this);
    this.ApiStore = apiStore;
  }

  setLoading = (loading: boolean) => {
    this.isLoading = loading;
  }

  async fetchTasksByUserId(userId: string) {
    this.setLoading(true);
    try {
      this.tasks = await this.ApiStore.TasksApiClient.getTasksByUserId(userId);
    } finally {
      this.setLoading(false);
    }
  }

  async approveTask(taskId: number) {
    this.setLoading(true);
    try {
      const success = await this.ApiStore.TasksApiClient.approveTask(taskId);
      if (success) {
        const task = this.tasks.find(t => t.id === taskId);
        if (task) {
          task.status = 'Approved';
          this.tasks = [...this.tasks];
        }
      }
      return success;
    } finally {
      this.setLoading(false);
    }
  }

  async rejectTask(taskId: number) {
    this.setLoading(true);
    try {
      const success = await this.ApiStore.TasksApiClient.rejectTask(taskId);
      if (success) {
        const task = this.tasks.find(t => t.id === taskId);
        if (task) {
          task.status = 'Rejected';
          this.tasks = [...this.tasks];
        }
      }
      return success;
    } finally {
      this.setLoading(false);
    }
  }
  
  // Add method for opening KanbanTasks
  async openTask(taskId: number) {
    this.setLoading(true);
    try {
      // First check if the openTask method exists on the API client
      if (typeof this.ApiStore.TasksApiClient.openTask === 'function') {
        const success = await this.ApiStore.TasksApiClient.openTask(taskId);
        // if (success) {
        //   const task = this.tasks.find(t => t.id === taskId);
        //   if (task) {
        //     task.status = 'Done';
        //     this.tasks = [...this.tasks];
        //   }
        // }
        return success;
      } else {
        // Fallback to mark as completed if openTask isn't available
        console.warn("openTask method not available, falling back to markTaskAsCompleted");
        return await this.ApiStore.TasksApiClient.markTaskAsCompleted(taskId);
      }
    } catch (error) {
      console.error("Error opening task:", error);
      return false;
    } finally {
      this.setLoading(false);
    }
  }
}

export default TaskStore;